<mat-card appearance="outlined" class="mat-elevation-z4">
    @if (recordId) {
        <mat-card-header>
            <mat-card-title>{{ formGroup.value.displayName }}</mat-card-title>
            <sl-dropdown>
                <sl-favorites [id]="recordId" [type]="EntityTypeEnum.Trader" />
            </sl-dropdown>
        </mat-card-header>
    }
    <mat-card-content>
        <form [formGroup]="formGroup" class="form-horizontal">
            <div class="row">
                <div class="col-md-12">
                    <h4>{{ 'General.General' | translate }}</h4>
                    <mat-divider />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="row">
                        <div class="col-md-12">
                            <sl-input type="text" placeholderKey="Traders.BpId" [control]="formGroup.controls['bpId']" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <sl-input type="text" placeholderKey="Contact.Name" [control]="formGroup.controls['name']" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <sl-input
                                type="text"
                                placeholderKey="Contact.NameSupplement"
                                [control]="formGroup.controls['nameSupplement']" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <sl-input type="text" placeholderKey="Traders.Department" [control]="formGroup.controls['department']" />
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <sl-input type="text" placeholderKey="Contact.DisplayName" [control]="formGroup.controls['displayName']" />
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="row">
                        <div class="col-lg-7">
                            <h4>
                                {{ 'Address.Title' | translate }}
                            </h4>
                            <mat-divider />
                            <sl-address [(address)]="address" [formGroup]="formGroup" (anyFieldBlur)="updateFormattedAddress()" />
                        </div>
                        <div class="col-lg-5">
                            <h4>
                                {{ 'Address.Formatted' | translate }}
                            </h4>
                            <mat-divider />
                            <span class="formatted-address">{{ formattedAddress }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="row">
                        <div class="col-lg-7">
                            <h4>
                                {{ 'Traders.AdditionalInformation' | translate }}
                            </h4>
                            <mat-divider />
                            <div class="row">
                                <div class="col-lg-12">
                                    <sl-input
                                        type="text"
                                        placeholderKey="Traders.PaymentType"
                                        [control]="formGroup.controls['paymentTypeDescription']" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <sl-input
                                        type="text"
                                        placeholderKey="Traders.PaymentIban"
                                        [control]="formGroup.controls['paymentIBAN']" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <sl-auto-complete
                                        placeholderKey="General.Language"
                                        [control]="formGroup.controls['languageId']"
                                        [observable]="metaResource.getLanguages()" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <mat-checkbox [formControl]="formGroup.controls['hasAregData'] | formControl">
                                                {{ 'Traders.HasAregData' | translate }}
                                            </mat-checkbox>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <mat-checkbox [formControl]="formGroup.controls['dividendRight'] | formControl">
                                                {{ 'Shareholders.DividendRight' | translate }}
                                            </mat-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-5">
                            <h4>
                                {{ 'ShareStatistics.SharesBalance' | translate }}
                            </h4>
                            <mat-divider />
                            <sl-share-info [id]="recordId!" [type]="ShareInfoTypeEnum.Trader" />
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </mat-card-content>
    <mat-card-actions>
        <button mat-button (click)="save()">
            {{ 'General.Submit' | translate }}
        </button>
    </mat-card-actions>
</mat-card>
